import { render, staticRenderFns } from "./ZomatoBadge.vue?vue&type=template&id=3784dc3e&"
import script from "./ZomatoBadge.vue?vue&type=script&lang=js&"
export * from "./ZomatoBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports